import React, { useState } from "react";
import CustomFaq from "../../../components/CustomFaq";
import CustomButton from "../../../components/CustomButton";
import { Link } from "react-router-dom";

const FaqSection = () => {
  const [data] = useState([
    {
      text: "How much does it cost to file a claim?",
      content:
        "Nothing upfront. Fly n' Claim operates on a No Win, No Fee basis. If we don’t win your case, you pay nothing.",
    },
    {
      text: "How long does the process take?",
      content:
        "Most claims are processed within 4 to 12 weeks, depending on the airline and the case complexity.",
    },
    {
      text: "What documents do I need to file a claim?",
      content:
        "At minimum: flight details, boarding pass (or e-ticket), and personal ID. Additional documents like baggage receipts or correspondence with the airline may be helpful.",
    },
    {
      text: "Am I eligible for compensation if my flight was delayed due to weather?",
      content:
        "Likely not. Weather delays are considered extraordinary circumstances and usually exempt airlines from paying compensation under EU261.",
    },
    {
      text: "Can I file a claim for multiple passengers on the same booking?",
      content:
        "Yes. You can include multiple passengers during the claim process. Each eligible passenger may be entitled to separate compensation.",
    },
  ]);

  return (
    <div className="container-wrapper faq-section">
      <div className="header-text-wrapper">
        <h1 className="header text-center">Frequently asked questions</h1>
        <div className="faq-content-wrapper">
          {data.map((item, index) => (
            <CustomFaq key={index} title={item.text} content={item.content} />
          ))}
        </div>

        <Link to={"/faq"}>
          <CustomButton type="danger" btnText={"View All FAQs"} />
        </Link>
      </div>
    </div>
  );
};

export default FaqSection;
